import { createApp } from 'vue'
import App from './App.vue'

import './assets/tailwind.css'

import 'tippy.js/dist/tippy.css'

createApp(App).mount('#app')
